import styled from 'styled-components'

export const TooltipContainer = styled.div`
  background: var(--bg-primary);
  border: 1px solid var(--border-tertiary);
  border-radius: var(--radius-brand);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  padding: var(--space-100);
  min-width: 314px;
  max-width: 400px;
  max-height: 280px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

export const ScrollableContent = styled.div`
  overflow-y: auto;
  overflow-x: hidden;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--bg-tertiary);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--bg-quaternary);
  }
`

export const ProductItem = styled.div`
  display: flex;
  align-items: center;
  padding: var(--space-300) var(--space-200);
  gap: var(--space-300);
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: var(--bg-secondary);
  }

  &:active {
    background: var(--bg-secondary-active);
  }

  /* First item should respect top border radius */
  &:first-child {
    &:hover {
      border-radius: var(--radius-brand) var(--radius-brand) 0 0;
    }
  }

  /* Last item should respect bottom border radius */
  &:last-child {
    &:hover {
      border-radius: 0 0 var(--radius-brand) var(--radius-brand);
    }
  }

  /* If it's the only item, respect all corners */
  &:first-child:last-child {
    &:hover {
      border-radius: var(--radius-brand);
    }
  }
`

export const Thumbnail = styled.div`
  width: 48px;
  height: 64px;
  border-radius: var(--radius-brand);
  overflow: hidden;
  flex-shrink: 0;
  background: var(--bg-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const ProductName = styled.div`
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
  color: var(--text-primary);
  flex: 1;
`
